import React from 'react';
import { bool, string, func, shape } from 'prop-types';
import _ from 'lodash';
import TranslationButton from '../TranslationButton';
import StudioSummary from './StudioSummary';

import './styles.scss';

const Summarize = ({
    createdAt,
    displayTranslationButton,
    translationConfig,
    studioName,
    studioSlug,
    componentName,
}) => (
    <span className="summarize">
        {createdAt && <time className="text-body-2">{createdAt}</time>}
        {studioName && <StudioSummary studioName={studioName} studioSlug={studioSlug} />}

        {displayTranslationButton && (
            <>
                <span className="separator"> | </span>
                <TranslationButton translationConfig={translationConfig} componentName={componentName} />
            </>
        )}
    </span>
);

Summarize.defaultProps = {
    displayTranslationButton: false,
    translationConfig: {
        toggleTranslation: _.noop,
        isTranslatedText: false,
        isLoading: false,
    },
};

Summarize.propTypes = {
    createdAt: string,
    displayTranslationButton: bool,
    translationConfig: shape({
        toggleTranslation: func,
        isTranslatedText: bool,
        isLoading: bool,
    }),
    studioName: string,
    studioSlug: string,
    componentName: string,
};

export default Summarize;
